//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

const CREATE_ADAPTIVE_LINK = 'CreateAdaptiveLink';
const CREATE_ONE_PAGE = 'CreateOnePage';

export const getUia = (state: ICuralateStore) => state.uiaModal;

// TODO: PD-261863 - Remove the feature flag usage once UIA Item Products is complete
export const getIsUiaReactPortItemProductsEnabled = createHasFeatureSelector(
  FeatureNames.UiaReactPortItemProducts,
);

export const getCurrentWorkflowName = createSelector(
  getUia,
  (uiaModal) => uiaModal.workflow.currentWorkflow?.name,
);

export const getIsTributaryWorkflow = createSelector(
  getCurrentWorkflowName,
  (workflow) => {
    return workflow === CREATE_ADAPTIVE_LINK;
  },
);

export const getIsOnePageWorkflow = createSelector(
  getCurrentWorkflowName,
  (workflow) => {
    return workflow === CREATE_ONE_PAGE;
  },
);
